import download from "downloadjs";
import { SERVER_URL } from "../../../../../config";

export const downloadReport = (isBackup = false) => {
    fetch(`${SERVER_URL}/opt-in/report/download`, {
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
         "isBackup": isBackup
        })
      })
        .then((res) => {
          if (Number(res.status) !== 200) throw new Error("Not Found");
   
          return res.blob();
        })
        .then((blob) => download(blob, "opt-in-report.zip"))
        .catch((err) => console.log(err));
};

